export var MessageType;
(function (MessageType) {
    MessageType["TEXT"] = "text";
    MessageType["FILE"] = "file";
    MessageType["IMAGE"] = "image";
    MessageType["VIDEO"] = "video";
    MessageType["AUDIO"] = "audio";
    MessageType["LINK"] = "link";
    MessageType["SYSTEM"] = "system";
})(MessageType || (MessageType = {}));
export var MessageStatus;
(function (MessageStatus) {
    MessageStatus["SENT"] = "sent";
    MessageStatus["DELIVERED"] = "delivered";
    MessageStatus["READ"] = "read";
    MessageStatus["FAILED"] = "failed";
})(MessageStatus || (MessageStatus = {}));
export var MessageTemplateCategory;
(function (MessageTemplateCategory) {
    MessageTemplateCategory["ONBOARDING"] = "onboarding";
    MessageTemplateCategory["TASK_ASSIGNMENT"] = "task_assignment";
    MessageTemplateCategory["MEETING_REMINDER"] = "meeting_reminder";
    MessageTemplateCategory["FEEDBACK"] = "feedback";
    MessageTemplateCategory["GOAL_SETTING"] = "goal_setting";
    MessageTemplateCategory["ENCOURAGEMENT"] = "encouragement";
    MessageTemplateCategory["CHECK_IN"] = "check_in";
    MessageTemplateCategory["OTHER"] = "other";
})(MessageTemplateCategory || (MessageTemplateCategory = {}));
// Events emitted by communication-service over the /messaging namespace.
export var MessagingSocketEvent;
(function (MessagingSocketEvent) {
    MessagingSocketEvent["MESSAGE_NEW"] = "message:new";
    MessagingSocketEvent["NOTIFICATION_UNREAD"] = "notification:unread";
    MessagingSocketEvent["NOTIFICATION_NEW"] = "notification:new";
    MessagingSocketEvent["MEMBER_ADDED"] = "room:member_added";
    MessagingSocketEvent["MEMBER_REMOVED"] = "room:member_removed";
    MessagingSocketEvent["ROOM_DISSOLVED"] = "room:dissolved";
})(MessagingSocketEvent || (MessagingSocketEvent = {}));
// Events emitted by clients over the /messaging namespace.
export var MessagingSocketClientEvent;
(function (MessagingSocketClientEvent) {
    MessagingSocketClientEvent["ROOM_JOIN"] = "room:join";
    MessagingSocketClientEvent["ROOM_LEAVE"] = "room:leave";
})(MessagingSocketClientEvent || (MessagingSocketClientEvent = {}));
//# sourceMappingURL=message.enum.js.map